export default {
  'Seeds': 'Use.Frs.SeedExpert',
  'Fertilizers': 'Use.Frs.FertAssist'
}
